import * as React from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { usePageTitle } from '../../../../../lib/hooks';
import { usePaymentStatus } from '../../../../../features/finance/hooks';
import { Button } from '../../../../../components/ui/Button';
import { Card, CardContent } from '../../../../../components/ui/Card';
import { Money } from "../../../../../components/ui/Money";
import { DataView } from "../../../../../components/ui/DataView";
import { PageHeader } from "../../../../../components/layout/PageHeader";

export const Route = createFileRoute('/_auth/finance/payments/$id/status')({
  component: PaymentStatusPage,
});

function PaymentStatusPage() {
  usePageTitle('Payment Status');
  const { id } = Route.useParams();
  const paymentstatusQuery = usePaymentStatus(id);

  return (
    <div className="max-w-lg mx-auto">
      <PageHeader title="Payment Status" />
      <DataView query={paymentstatusQuery}>
        {(data) => (
          <Card className="flex flex-col items-center justify-center min-h-[200px]">
            <CardContent className="p-6 flex flex-col items-center w-full">
              {(data.status === 'CREATED' || data.status === 'PENDING') && (
                <div className="flex flex-col items-center">
                  <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-info-500 mb-4"></div>
                  <p className="text-text-secondary">Checking payment status...</p>
                </div>
              )}

              {data.status === 'SUCCESS' && (
                <div className="flex flex-col items-center text-center">
                  <div className="text-success-500 mb-4">
                    <svg className="w-16 h-16" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                  </div>
                  <p className="text-xl font-bold text-text-primary mb-2">Payment Successful</p>
                  <p className="text-text-secondary mb-1"><Money paise={data.amount} /></p>
                  {data.providerRef && (
                    <p className="text-text-secondary mb-6">Reference ID: {data.providerRef}</p>
                  )}
                  <Button variant="primary" onClick={() => window.print()}>Print Receipt</Button>
                </div>
              )}

              {(data.status === 'FAILED' || data.status === 'EXPIRED') && (
                <div className="flex flex-col items-center text-center">
                  <div className="text-danger-500 mb-4">
                    <svg className="w-16 h-16" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                    </svg>
                  </div>
                  <p className="text-xl font-bold text-text-primary mb-2">
                    {data.status === 'EXPIRED' ? 'Payment Expired' : 'Payment Failed'}
                  </p>
                  <p className="text-danger-text mb-6">
                    {data.failureReason || (data.status === 'EXPIRED' ? 'This payment request was not completed in time.' : 'An unknown error occurred.')}
                  </p>
                </div>
              )}

              {data.status === 'REFUNDED' && (
                <div className="flex flex-col items-center text-center">
                  <p className="text-xl font-bold text-text-primary mb-2">Payment Refunded</p>
                  <p className="text-text-secondary mb-1"><Money paise={data.amount} /></p>
                </div>
              )}
            </CardContent>
          </Card>
        )}
      </DataView>
    </div>
  );
}
